import * as z from 'zod';
import { createSelectSchema } from 'drizzle-zod';
import type { QueryResult } from '@iichi/schema-database/types/item-option';
import * as schema from '@iichi/schema-database';

export const itemOptionVariantSchema = createSelectSchema(schema.itemOptionVariant).pick({
  itemOptionVariantSlug: true,
  name: true,
  order: true,
  price: true,
});

export const itemOptionSchema = createSelectSchema(schema.itemOption)
  .pick({
    itemOptionSlug: true,
    name: true,
    order: true,
    shopId: true,
  })
  .extend({
    itemOptionVariants: itemOptionVariantSchema.array(),
    required: z.coerce.boolean(),
  });

export type ItemOption = z.infer<typeof itemOptionSchema>;

export const serialize = (data: QueryResult): ItemOption => {
  const itemOption = {
    ...data,
    itemOptionVariants: data.itemOptionVariants?.map((variant) => itemOptionVariantSchema.parse(variant)) || [],
  };
  return itemOptionSchema.parse(itemOption);
};
